module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0157.jpg?v=c18197e9";